import type { TwoFAStep } from "./types";

export const TWO_FA_REDIRECTION = 'mandatory_2fa_redirection'

export const STEP_ORDER: Exclude<TwoFAStep, null>[] = ['intro', 'qr', 'verify', 'success'];